import { render } from "./AddNotePage.vue?vue&type=template&id=2af74f9a&ts=true"
import script from "./AddNotePage.vue?vue&type=script&lang=ts"
export * from "./AddNotePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__